module.exports = __webpack_public_path__ + "../public/img/cash.641134f8.png";